<template lang="pug">
    .flex
        .control.flex-grow(style="margin-right:0.25rem")
            .select.is-fullwidth
                select(v-model="selected", :disabled='readonly')
                    option(v-for='c in addons' :value='c') {{c.code}} {{c.name}} {{c.description}}
        .control.flex-min
            button.button.is-info(@click="$emit('added', selected); selected=null")
                font-awesome-icon(icon="plus")

</template>

<script>
import { mapState } from "vuex";

export default {
  name: "AddonPicker",
  data: function() {
    return {
      selected: null
    };
  },
  props: ["addons", "readonly"]
};
</script>

<style scoped lang="less">
</style>